module.exports = __webpack_public_path__ + "img/fumigate.b7078559.png";